import {flashTypes} from 'actions/types'

export const setFlash = payload => dispatch => {
  dispatch({type: flashTypes.SET_FLASH, payload})
}

export const clearFlash = () => dispatch => {
  dispatch({type: flashTypes.CLEAR_FLASH})
}
